import { FORM_TYPE } from "../../../components/Basic/InputForm";
import {
    EQUIPMENT_TYPE,
    OPERATION_TYPE,
    operationType,
    STORAGE_GROUP_TYPE,
    TREATMENT_TYPE,
    treatmentType,
    VESSEL_TYPE
} from "../../../util/varibles/constants";
import { IVessel } from "../../../util/varibles/interface";
import { NotifyCode } from "../../../util/varibles/message";
import { Symbol } from "../../../util/varibles/template";
import { formModel, funcValidation, IFormItemModel, IFormModel } from "../../../util/varibles/validation";
import { KEY_SPLIT } from "../constants";
import { validateCostInformation } from './_component/CostInformation';

export const optionOpTypes = {
    [OPERATION_TYPE.HARVEST]: operationType[OPERATION_TYPE.HARVEST],
    [OPERATION_TYPE.EVENT]: operationType[OPERATION_TYPE.EVENT],
    [OPERATION_TYPE.TRANSPORT]: operationType[OPERATION_TYPE.TRANSPORT],
    [OPERATION_TYPE.SERVICE]: operationType[OPERATION_TYPE.SERVICE],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.FRESHWATER].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.FRESHWATER],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.HYDROGENPEROXIDE].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.HYDROGENPEROXIDE],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.SALTWATER].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.SALTWATER],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.ECTOSAN].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.ECTOSAN],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.FLS].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.FLS],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.OPTILICER].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.OPTILICER],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.SALMOSAN].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.SALMOSAN],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.SORTING].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.SORTING],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.THERMOLICER].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.THERMOLICER],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.WELLFIGHTER].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.WELLFIGHTER],
    [[OPERATION_TYPE.TREATMENT, TREATMENT_TYPE.SALMOCLEAN].join(KEY_SPLIT)]: treatmentType[TREATMENT_TYPE.SALMOCLEAN],
}

export const jobName = (opType: string, subType: string = ''): string => {
    if (`${opType}` === `${OPERATION_TYPE.TREATMENT}`) {
        const list = subType.split(',');
        return list.map(key => {
            const { name = '' } = treatmentType[key] || {};
            return name
        }).join(' & ');
    } else {
        const { name = '' } = operationType[opType] || {};
        return name
    }
}


export const vesselForm: { [id: string]: { condition?: (vessel: Partial<IVessel>) => boolean } & IFormItemModel } = {
    name: formModel.name,
    type: { label: 'Type', rules: { require: true }, type: FORM_TYPE.SELECT },
    contact: { label: 'Contact number', type: FORM_TYPE.TEXT, rules: {} },
    length: { label: 'Length', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: 'meter' },
    width: { label: 'Width', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: 'meter' },
    speed: { label: 'Speed', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: 'knots' },
    capacity: {
        label: 'Capacity',
        rules: { requireZero: true },
        type: FORM_TYPE.NUMBER,
        suffix: 'tons',
        condition: (vessel) => vessel.type !== VESSEL_TYPE.SERVICE
    },
    harvest_capacity: {
        label: 'Harvesting speed',
        rules: { requireZero: true },
        type: FORM_TYPE.NUMBER,
        suffix: 'fish/h',
        condition: (vessel) => vessel.type !== VESSEL_TYPE.SERVICE
    },
    factory_discharge: {
        label: 'Factory discharging speed',
        rules: { requireZero: true },
        type: FORM_TYPE.NUMBER,
        suffix: 'ton/h',
        condition: (vessel) => vessel.type !== VESSEL_TYPE.SERVICE
    },
    waiting_unit_capacity: {
        label: 'Waiting unit discharging speed',
        rules: { requireZero: true },
        type: FORM_TYPE.NUMBER,
        suffix: 'ton/h',
        condition: (vessel) => vessel.type === VESSEL_TYPE.WELL_BOAT
    },
    cleaning_time: { label: 'Cleaning time', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: 'minute' },
    mmsi: { label: 'MMSI', type: FORM_TYPE.TEXT, rules: {} },
}

export const storageForm: { [id: string]: { [id: string]: IFormModel } } = {
    [STORAGE_GROUP_TYPE.TREATMENT]: {
        [EQUIPMENT_TYPE.TANK]: {
            name: formModel.name,
            value: { label: 'Volume', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: Symbol.m3 },
            speed: { label: 'Speed', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: 't/h' },
        }
    },
    [STORAGE_GROUP_TYPE.SERVICE]: {
        [EQUIPMENT_TYPE.TANK]: {
            name: formModel.name,
            value: { label: 'Volume', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: Symbol.m3 },
            materials: { label: 'Materials', rules: { requireArray: true }, type: FORM_TYPE.SELECT, suffix: Symbol.m3 },
        },
        [EQUIPMENT_TYPE.CARGO]: {
            name: formModel.name,
            loading_speed: { label: 'Loading speed', suffix: 't/h', rules: { requireZero: true }, type: FORM_TYPE.NUMBER },
            unloading_speed: {
                label: 'Unloading speed',
                suffix: 't/h',
                rules: { requireZero: true },
                type: FORM_TYPE.NUMBER
            },
        }
    }
}

export const equipmentForm: IFormModel = {
    name: formModel.name,
    value: { label: 'Speed', rules: { requireZero: true }, type: FORM_TYPE.NUMBER, suffix: 't/h' },
}

export const capabilityKeys: {
    [id: string]: { form: IFormModel, actions: string[], errorKey: 'capabilities' | 'storages' }
} = {
    [EQUIPMENT_TYPE.DIVING]: {
        form: { name: formModel.name, max_length: formModel.max_length },
        actions: ['updateCapability', 'deleteCapability'],
        errorKey: 'capabilities'
    },
    [EQUIPMENT_TYPE.ROV]: {
        form: { name: formModel.name, max_length: formModel.max_length },
        actions: ['updateCapability', 'deleteCapability'],
        errorKey: 'capabilities'
    },
    [EQUIPMENT_TYPE.CRANE]: {
        form: { name: formModel.name, max_capacity: formModel.max_capacity, max_length: formModel.max_length },
        actions: ['updateCapability', 'deleteCapability'],
        errorKey: 'capabilities'
    },
    [EQUIPMENT_TYPE.WINCH]: {
        form: { name: formModel.name, max_length: formModel.max_length },
        actions: ['updateCapability', 'deleteCapability'],
        errorKey: 'capabilities'
    },
    [EQUIPMENT_TYPE.TANK]: {
        form: storageForm[STORAGE_GROUP_TYPE.SERVICE][EQUIPMENT_TYPE.TANK],
        actions: ['updateStorage', 'deleteStorage'],
        errorKey: 'storages'
    },
    [EQUIPMENT_TYPE.CARGO]: {
        form: storageForm[STORAGE_GROUP_TYPE.SERVICE][EQUIPMENT_TYPE.CARGO],
        actions: ['updateStorage', 'deleteStorage'],
        errorKey: 'storages'
    },
}

export const validateForm = ({ vessel }: { vessel: IVessel | Partial<IVessel> }): any => {
    const { storages = [], equipments = [], capabilities = [] } = vessel;
    const result: any = Object.keys(vesselForm).reduce((rs: {
        [key: string]: {
            [rule: string]: NotifyCode
        }
    }, key) => {
        const { [key]: value } = vessel as any;
        const { rules, condition } = vesselForm[key];
        if (!condition || condition(vessel))
            Object.keys(rules).forEach(rule => {
                const check = funcValidation[rule];
                if (check) {
                    const result = check(value);
                    if (result)
                        rs[key] = { ...rs[key] || {}, [rule]: result };
                }
            })
        return rs;
    }, {})

    let errorCustom = storages.reduce((rs: {
        [index: string]: { [key: string]: { [rule: string]: NotifyCode } }
    }, item, i) => {
        const { type, group_type = "treatment-tank" } = item;
        const validateForm = storageForm[group_type][type] || {};
        Object.keys(validateForm).forEach(key => {
            const { [key]: value } = item as any;
            const { rules } = validateForm[key];
            Object.keys(rules).forEach(rule => {
                const check = funcValidation[rule];
                if (check) {
                    const result = check(value);
                    if (result)
                        rs[i] = { ...rs[i] || {}, [key]: { [rule]: result } };
                }
            })
        })
        return rs;
    }, {});

    if (Object.keys(errorCustom).length > 0)
        result.storages = errorCustom

    errorCustom = equipments.reduce((rs: {
        [index: string]: { [key: string]: { [rule: string]: NotifyCode } }
    }, item, i) => {
        Object.keys(equipmentForm).forEach(key => {
            const { [key]: value } = item as any;
            const { rules } = equipmentForm[key];
            Object.keys(rules).forEach(rule => {
                const check = funcValidation[rule];
                if (check) {
                    const result = check(value);
                    if (result)
                        rs[i] = { ...rs[i] || {}, [key]: { [rule]: result } };
                }
            })
        })
        return rs;
    }, {});

    if (Object.keys(errorCustom).length > 0)
        result.equipments = errorCustom

    errorCustom = capabilities.reduce((rs: {
        [index: string]: { [key: string]: { [rule: string]: NotifyCode } }
    }, value, i) => {
        const { form } = capabilityKeys[value.type] || {};
        if (form) {
            Object.keys(form).forEach(key => {
                const { rules } = form[key];

                Object.keys(rules).forEach(rule => {
                    const check = funcValidation[rule];
                    if (check) {
                        const result = check(value[key]);
                        if (result)
                            rs[i] = { ...rs[i] || {}, [key]: { [rule]: result } };
                    }
                })
            })
        }
        return rs;
    }, {});

    if (Object.keys(errorCustom).length > 0)
        result.capabilities = errorCustom

    const costInformationErrors = validateCostInformation(vessel);
    if (Object.keys(costInformationErrors).length > 0)
        result.cost_information = costInformationErrors;

    return result
}
